export const projectName = process.env.REACT_APP_PROJECT_NAME;
export const marketplaceUrl = "https://nft.renai.io/auth/listings";